<template>
  <div :id="id" :class="{[wrapperClass]: true, disabled, 'disabled-gray': disabled}">
    <toast v-if="message" :kind="message.status">
      <template #message-content>
        {{ message.message }}
      </template>
    </toast>
    <div class="toggle-and-label">
      <!-- When this toggle is being rendered onto the form in the page, we need to include this hack so
           Rails can get the true/false value of the checkbox. this mimics the behavior of rails form helpers -->
      <input v-if="!persist" :name="field" type="hidden" value="0">

      <vue-toggle :id="`${field}-toggle-input`" ref="toggle" :name="field" :disabled="disabled"
                  :model-value="initialValue" :labelledby="`${field}-label`" class="toggle d-inline-block"
                  @change="onChange" />

      <label :id="`${field}-label`" class="toggle-label-text" @click="toggleValue" v-html="label" />
    </div>
    <p v-if="hint" class="text-muted">
      {{ hint }}
    </p>
  </div>
</template>

<script>
import VueToggle from '@vueform/toggle'
import Toast from '../toast'
import PersistAndToast from './mixins/persist-and-toast'
import '@vueform/toggle/themes/default.css'

export default {
  components: { Toast, VueToggle },
  mixins: [PersistAndToast],

  props: {
    id: {
      type: String,
      required: false
    },
    initialValue: {
      type: Boolean,
      required: false,
      default: false
    },
    label: {
      type: String,
      required: false
    },
    hint: {
      type: String,
      required: false
    },
    wrapperClass: {
      type: String,
      required: false,
      default: 'checkbox'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  emits: ['change'],

  data() {
    return {
      rubberBandOnError: true
    }
  },

  methods: {
    focus() {
      // no-op: vueform/toggle doesn't support programmatically setting focus
    },

    onChange(newValue) {
      this.$emit('change', {value: newValue})

      if (this.persist === true) {
        this.save({value: newValue})
      }
    },

    toggleValue() {
      this.$refs.toggle.toggle()
    }
  }
}
</script>

<style lang="scss" scoped>
  @use "~common_styles/breakpoints" as breakpoints;
  @use "~friendship_styles/colors" as colors;

  .toggle-and-label {
    margin-bottom: 1rem;
  }

  .checkbox .toggle-and-label {
    padding-left: 0;
  }
  .toggle-label-text {
    padding-left: 10px;
  }
  @include breakpoints.screen-md-up {
    .text-muted {
      margin-left: 65px;
    }
  }

  .disabled-gray {
    .toggle-label-text {
      color: colors.$unobtrusive-text-color;
    }
  }

  .toggle {
    border: none;

    --toggle-width: 45px;

    // Additional variables for colors are set in app/assets/stylesheets/phoenix/_forms.scss
    --toggle-bg-off: #999999;
    --toggle-border-off: #999999;
  }
</style>
